// extracted by mini-css-extract-plugin
module.exports = {"NavLinks":"NavLinks_NavLinks__1Rbir","about":"NavLinks_about__2Ya6Z","faq":"NavLinks_faq__3G1uN"};